<template>
  <div>
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">近一年前十供应商信息</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell itemno">排名</div>
        <div class="datacell">供应商名称</div>
        <div class="datacell">销售金额</div>
        <div class="datacell">金额占比</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.supplierList">
        <div class="datacell itemno">{{ index + 1 }}</div>
        <div class="datacell">{{ item.salerName }}</div>
        <div class="datacell">{{ item.totalAmount }}</div>
        <div class="datacell">{{ item.rateSalerAmount }}</div>
      </div>
    </div>
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">近一年前十销售客户信息</div>
    </div>
    <div class="datatable tableinfo2">
      <div class="dataitem datahead">
        <div class="datacell">排名</div>
        <div class="datacell">购方名称</div>
        <div class="datacell">销售金额</div>
        <div class="datacell">金额占比</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.customertList">
        <div class="datacell">{{ index + 1 }}</div>
        <div class="datacell">{{ item.buyerName }}</div>
        <div class="datacell">{{ item.totalAmount }}</div>
        <div class="datacell">{{ item.rateBuyerAmount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object
    },
    createTime: {
      type: String,
    }
  }
}
</script>


<style></style>